export default "__VITE_ASSET__IP0guvs4__"